import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../css/contact.css';

const Contact = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    industry: '',
    budget: '',
    hearAbout: '',
    otherText: '',
    message: '',
    newsletter: false
  });
  const [showOtherInput, setShowOtherInput] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });

    // Toggle "other" input visibility
    if (name === 'hearAbout') {
      setShowOtherInput(value === 'other');
    }
  };

  const validateForm = () => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const phonePattern = /^\+?[0-9]{10,15}$/;

    if (!emailPattern.test(formData.email)) {
      alert('Please enter a valid email address.');
      return false;
    }

    if (formData.phone && !phonePattern.test(formData.phone)) {
      alert('Please enter a valid phone number.');
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setSubmitting(true);

    const data = {
      fields: [
        {
          name: 'firstname',
          value: formData.firstName
        },
        {
          name: 'lastname',
          value: formData.lastName
        },
        {
          name: 'email',
          value: formData.email
        },
        {
          name: 'phone',
          value: formData.phone
        },
        {
          name: 'industry',
          value: formData.industry
        },
        {
          name: 'message',
          value: formData.message
        },
        {
          name: 'budget',
          value: formData.budget
        },
        {
          name: 'how_did_you_hear_about_us',
          value: formData.hearAbout === 'other' ? formData.otherText : formData.hearAbout
        },
        {
          name: 'newsletter_subscription',
          value: formData.newsletter ? 'Yes' : 'No'
        }
      ],
      context: {
        pageUri: window.location.href,
        pageName: document.title
      }
    };

    const hubspot_portalId = '46060997';
    const hubspot_formId = '26965ec3-499c-476e-83aa-384b3e94b9fc';
    const url = `https://api.hsforms.com/submissions/v3/integration/submit/${hubspot_portalId}/${hubspot_formId}`;

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (response.ok) {
        alert('Thank you! Your message has been sent successfully.');
        // Reset form
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          industry: '',
          budget: '',
          hearAbout: '',
          otherText: '',
          message: '',
          newsletter: false
        });
        setShowOtherInput(false);
      } else {
        alert('There was a problem with your submission. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('There was an error processing your submission. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const copyBadgeCode = () => {
    const badgeCode = document.getElementById('badge-code');
    badgeCode.select();
    badgeCode.setSelectionRange(0, 99999);
    document.execCommand('copy');
    alert('Badge code copied to clipboard.');
  };

  return (
    <main>
      {/* Book a Discovery Call Section */}
      <section className="badge-section">
        <div className="container">
          <h2>Book a Discovery Call</h2>
          <p>
            Ready to explore how UnsupervisedBias can streamline your business operations and improve efficiency?
            Book a discovery call with us today.
          </p>
          <button
            onClick={() => navigate('/book-call')}
            className="cta-button-submit copy-button"
          >
            Book Call
          </button>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-section">
        <div className="container">
          <div className="contact-info">
            <h1>Contact Us</h1>
            <p>
              Our business offers AI-powered data automations, covering infrastructure design, integration,
              and implementation. We build scalable, reliable data foundations for your AI projects.
            </p>
            <p>
              Get in touch with UnsupervisedBias to learn how our AI solutions can streamline your operations.
            </p>
          </div>
          <form id="contact-form" onSubmit={handleSubmit}>
            <div className="form-group-inline">
              <div className="form-group">
                <label htmlFor="firstName">
                  First Name: <span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="lastName">
                  Last Name: <span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="email">
                Email: <span className="required">*</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Phone Number:</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="industry">
                Industry: <span className="required">*</span>
              </label>
              <select
                id="industry"
                name="industry"
                value={formData.industry}
                onChange={handleChange}
                required
              >
                <option value="">Select an industry</option>
                <option value="technology">Technology</option>
                <option value="healthcare">Healthcare</option>
                <option value="finance">Finance</option>
                <option value="retail">Retail</option>
                <option value="manufacturing">Manufacturing</option>
                <option value="education">Education</option>
                <option value="transportation">Transportation</option>
                <option value="hospitality">Hospitality</option>
                <option value="law">Law</option>
                <option value="construction">Construction</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="budget">
                Budget:<span className="required">*</span>
              </label>
              <select
                id="budget"
                name="budget"
                value={formData.budget}
                onChange={handleChange}
                required
              >
                <option value="">Select your budget</option>
                <option value="General Inquiry">N/A - General Inquiry</option>
                <option value="under-5000">$0 - $5,000</option>
                <option value="5000-10000">$5,000 - $10,000</option>
                <option value="10000-50000">$10,000 - $50,000</option>
                <option value="50000+">Over $50,000</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="hearAbout">How did you hear about us?</label>
              <select
                id="hearAbout"
                name="hearAbout"
                value={formData.hearAbout}
                onChange={handleChange}
              >
                <option value="">Select an option</option>
                <option value="friend-family-colleague">Friend/Family/Colleague</option>
                <option value="Google">Google</option>
                <option value="Instagram">Instagram</option>
                <option value="YouTube">YouTube</option>
                <option value="Facebook">Facebook</option>
                <option value="LinkedIn">LinkedIn</option>
                <option value="Reddit">Reddit</option>
                <option value="Twitter">Twitter</option>
                <option value="Medium">Medium</option>
                <option value="TikTok">TikTok</option>
                <option value="other-search-engine">Other Search Engine</option>
                <option value="other">Other</option>
              </select>
            </div>
            {showOtherInput && (
              <div id="other-input" className="form-group">
                <label htmlFor="otherText">
                  Thank you for taking a moment to let us know how you found us!
                </label>
                <textarea
                  id="other-text"
                  name="otherText"
                  rows="4"
                  value={formData.otherText}
                  onChange={handleChange}
                />
              </div>
            )}
            <div className="form-group message">
              <label htmlFor="message">
                General Inquiry / Project Description:<span className="required">*</span>
              </label>
              <textarea
                id="message"
                name="message"
                rows="4"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group checkbox-group">
              <label htmlFor="newsletter">
                <input
                  type="checkbox"
                  id="newsletter"
                  name="newsletter"
                  checked={formData.newsletter}
                  onChange={handleChange}
                />
                Subscribe to our Newsletter
              </label>
            </div>
            <button type="submit" className="cta-button-submit" disabled={submitting}>
              {submitting ? 'Submitting...' : 'Submit'}
            </button>
          </form>
        </div>
      </section>

      {/* Badge Section */}
      <section className="badge-section">
        <div className="container">
          <h2>Support UnsupervisedBias</h2>
          <p>
            Share our badge on your blog or website to support our brand with backlinking. Simply copy the code
            below and paste it anywhere between the <code>&lt;html&gt;</code> tags on your blog or website.
          </p>
          <p>
            If you use a website builder or CMS, you can use Google's{' '}
            <a href="https://support.google.com/tagmanager/answer/12403447" target="_blank" rel="noopener noreferrer">
              instructions
            </a>{' '}
            for inserting code snippets.
          </p>
          <textarea id="badge-code" rows="6" readOnly value={`<a href="https://unsupervisedbias.com/" target="_blank" style="position: fixed; bottom: 5px; left: 10px; z-index: 1000;"><img src="https://unsupervisedbias.com/img/UB.svg" alt="Join UnsupervisedBias" style="width: 32px; height: auto;"></a>`}>
          </textarea>
          <br />
          <button className="cta-button-submit copy-button" onClick={copyBadgeCode}>
            Copy Code
          </button>
          <p></p>
        </div>
      </section>
    </main>
  );
};

export default Contact;
